import type {
  DrawingToolInstance,
  SinglePriceCoordinates,
  ChartLayout,
  PriceToY,
} from "./types";
import { applyLineStyle, drawHandleCircle } from "./drawHelpers";

export function getHorizontalLineHandleX(layout: ChartLayout): number {
  return layout.left + (layout.width - layout.left - layout.right) / 2;
}

export function drawHorizontalLine(
  ctx: CanvasRenderingContext2D,
  coords: SinglePriceCoordinates,
  instance: DrawingToolInstance,
  layout: ChartLayout,
  priceToY: PriceToY,
  draggingPrice?: number,
) {
  const price = draggingPrice ?? coords.price;
  const y = priceToY(price);
  const chartBottom = layout.height - layout.bottom;
  if (y < layout.top || y > chartBottom) return;

  applyLineStyle(ctx, instance.mainLine.color, instance.mainLine.width, instance.mainLine.opacity);
  ctx.beginPath();
  ctx.moveTo(layout.left, y);
  ctx.lineTo(layout.width - layout.right, y);
  ctx.stroke();

  ctx.globalAlpha = 1;
  ctx.fillStyle = instance.mainLine.color;
  ctx.font = "10px Arial";
  ctx.textAlign = "right";
  ctx.textBaseline = "middle";
  ctx.fillText(price.toFixed(5), layout.width - layout.right - 4, y - 8);

  drawHandleCircle(ctx, getHorizontalLineHandleX(layout), y, instance.mainLine.color);
}
